import Header from '../components/Header/Header';
import Footer from '../components/Footer/Footer';
import styles from './TermsPage.module.css';

export default function TermsPage() {
  return (
    <>
      <Header />
      <main className={styles.termsMain}>
        <div className={styles.container}>
          <h1>Termos e Condições de Uso</h1>
          
          <h2>1. Quem Somos</h2>
          <p>
            A Traily é uma plataforma B2B que conecta empresas ao entretenimento, oferecendo soluções para gestão e distribuição de conteúdos digitais como ingressos de cinema, games, cash e gift cards. Atuamos de forma transparente, simples e segura, cuidando dos bastidores para que sua empresa entregue experiências incríveis aos clientes ou colaboradores.
          </p>

          <h2>2. Aceite dos Termos</h2>
          <p>
            Ao acessar ou utilizar a plataforma Traily, você (empresa contratante ou usuário autorizado) concorda com estes Termos e Condições, bem como com nossa Política de Privacidade. Caso não esteja de acordo, não utilize a plataforma.
          </p>

          <h2>3. Serviços Oferecidos</h2>
          <ul>
            <li>Curadoria estratégica de conteúdo, com parceiros líderes do mercado de entretenimento.</li>
            <li>Distribuição inteligente e automatizada de vouchers digitais, segmentados para públicos específicos, com rastreabilidade e segurança.</li>
            <li>Gestão integrada e simplificada, desde a negociação até a entrega dos conteúdos.</li>
            <li>Produtos nas seguintes categorias:</li>
            <ul>
              <li>Nebula Cinema</li>
              <li>Nebula Ingresso.com</li>
              <li>Nebula Games</li>
              <li>Nebula Cash &amp; Gift Cards</li>
            </ul>
          </ul>

          <h2>4. Cadastro e Responsabilidades</h2>
          <ul>
            <li>O acesso é restrito a empresas contratantes e usuários por elas autorizados.</li>
            <li>É de responsabilidade da empresa contratante:</li>
            <ul>
              <li>Garantir a veracidade das informações fornecidas.</li>
              <li>Proteger as credenciais de acesso à plataforma.</li>
              <li>Informar imediatamente qualquer uso indevido ou suspeita de violação de segurança.</li>
            </ul>
          </ul>

          <h2>5. Uso Correto da Plataforma</h2>
          <ul>
            <li>É proibido utilizar a plataforma para fins ilícitos ou que contrariem a legislação vigente.</li>
            <li>Não é permitido reproduzir, copiar, modificar, distribuir ou explorar comercialmente qualquer parte da plataforma ou de seu conteúdo sem autorização prévia e expressa da Traily.</li>
          </ul>

          <h2>6. Conteúdos e Limitações</h2>
          <ul>
            <li>
              A Traily realiza a distribuição de vouchers digitais, mas não é responsável:
              <ul>
                <li>Pelo conteúdo final fornecido pelas redes de cinema, plataformas de games ou terceiros parceiros.</li>
                <li>Pela experiência oferecida pelos parceiros após o resgate do voucher.</li>
              </ul>
            </li>
            <li>Os vouchers possuem prazos de validade definidos no momento da negociação com cada empresa contratante.</li>
          </ul>

          <h2>7. Disponibilidade da Plataforma</h2>
          <ul>
            <li>A Traily busca manter a plataforma disponível e operante continuamente, mas não garante funcionamento ininterrupto ou livre de falhas.</li>
            <li>A plataforma pode passar por manutenções programadas, e nesses casos, a empresa contratante será comunicada sempre que possível.</li>
          </ul>

          <h2>8. Propriedade Intelectual</h2>
          <ul>
            <li>Todos os direitos sobre a marca, identidade visual, textos, imagens, códigos, layouts e demais conteúdos são de propriedade da Traily ou de seus parceiros.</li>
            <li>O uso indevido poderá acarretar responsabilização civil e criminal.</li>
          </ul>

          <h2>9. Preços e Condições Comerciais</h2>
          <ul>
            <li>Todas as condições comerciais, valores e prazos são definidos em contrato ou proposta específica firmada entre a Traily e a empresa contratante.</li>
            <li>O não cumprimento dos pagamentos poderá resultar na suspensão dos serviços.</li>
          </ul>

          <h2>10. Alterações nestes Termos</h2>
          <p>
            Estes Termos poderão ser atualizados periodicamente. A versão vigente estará sempre disponível no site da Traily. A continuidade de uso após mudanças implica aceitação dos novos termos.
          </p>

          <h2>11. Política de Privacidade</h2>
          <p>
            A coleta e o tratamento de dados pessoais seguem as diretrizes da LGPD (Lei Geral de Proteção de Dados) e estão detalhados em nossa Política de Privacidade, disponível em <a href="#privacidade">política de privacidade</a>.
          </p>

          <h2>12. Contato</h2>
          <p>
            Em caso de dúvidas ou solicitações, entre em contato pelo e-mail: <a href="mailto:contato@traily.digital">contato@traily.digital</a>.
          </p>
        </div>
      </main>
      <Footer />
    </>
  );
}
